import React from 'react';

export const SEARCH_INPUT_ID = 'faq_search_input';

function useSearch() {
  const inputValue = React.useRef('');
  const [submitStatus, setSubmitStatus] = React.useState(false);

  const handleChange = (event?: React.ChangeEvent<HTMLInputElement>) => {
    if (event) {
      inputValue.current = (event.target as HTMLInputElement).value;
    }
  };

  const handleKeyDown = (event?: React.KeyboardEvent<HTMLInputElement>) => {
    const key = (event as React.KeyboardEvent<HTMLInputElement>).key.toLowerCase();
    if (key === 'enter') {
      handleSubmit();
    }
  };

  const handleSubmit = () => {
    if (inputValue.current.length > 1) {
      // TODO add search log here
      setSubmitStatus(true);
    }
  };

  const getInputValue = () => {
    return inputValue.current;
  };

  React.useEffect(() => {
    if (submitStatus) {
      setSubmitStatus(false);
    }
  }, [submitStatus]);

  return {
    submitStatus,
    getInputValue,
    onChange: handleChange,
    onKeyDown: handleKeyDown,
    onSubmit: handleSubmit,
  };
}

export default useSearch;
